import moment from "moment-timezone";
import _ from "lodash";

/**
 * @typedef {{start: string, end: string, label: string}} Timestamp
 * @typedef {{createdAt: string, startDate: string, date: string, endDate: string}} ActivityItem
 */

/**
 * Get the data for line charts displaying activity over time.
 * @param {ProjectMetricItem[]|EventMetricItem[]} projectsOrEvents
 * @param {Timestamp[]} timestamps
 * @returns {{series: [{name: string, data: number[]},{name: string, data: number[]},{name: string, data: number[]},{name: string, data: number[]}], labels: string[]}}
 */
export default function getActivityChartData(projectsOrEvents, timestamps) {
  const normalizedProjects = projectsOrEvents.map(project => ({
    ...project,
    createdAt: moment(project.createdAt),
    startDate: project.startDate
      ? moment(project.startDate)
      : project.date
        ? moment(project.date)
        : null,
    endDate: project.endDate
      ? moment(project.endDate)
      : project.date
        ? moment(project.date)
        : null
  }))

  const seriesData = _.map(timestamps, ({ start, end, label }) => {
    const startMoment = moment(start);
    const endMoment = moment(end);

    const counts = _.transform(
      normalizedProjects,
      (acc, event) => {
        const { createdAt, startDate, endDate } = event;

        const endsDuring =
          endDate && endDate.isBetween(startMoment, endMoment, null, "[]");

        if (createdAt.isBetween(startMoment, endMoment, null, "[]")) {
          acc.new++;
        }

        const startsDuring =
          startDate &&
          startDate.isBetween(startMoment, endMoment, null, "[]");

        const spansPeriod =
          startDate &&
          endDate &&
          startDate.isBefore(startMoment) &&
          endDate.isAfter(endMoment);

        if (startsDuring || endsDuring || spansPeriod) {
          acc.active++;
        }

        if (event.completed && endsDuring) {
          acc.completed++;
        }

        if (event.cancelled && endsDuring) {
          acc.cancelled++;
        }
      },
      { new: 0, active: 0, completed: 0, cancelled: 0 }
    );

    return { label, counts };
  })

  return {
    series: [
      {
        name: 'New',
        data: seriesData.map(d => d.counts.new)
      },
      {
        name: 'Active',
        data: seriesData.map(d => d.counts.active)
      },
      {
        name: 'Completed',
        data: seriesData.map(d => d.counts.completed)
      },
      {
        name: 'Cancelled',
        data: seriesData.map(d => d.counts.cancelled)
      }
    ],
    labels: seriesData.map(d => d.label)
  }
}
